var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconIosFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.342c-.573 1.302-.849 1.883-1.586 3.032-1.031 1.605-2.486 3.609-4.283 3.622-1.6.014-2.013-1.068-4.186-1.05-2.17.011-2.623 1.07-4.225 1.054-1.8-.017-3.175-1.822-4.207-3.425-2.885-4.494-3.19-9.763-1.407-12.565 1.262-1.987 3.256-3.155 5.13-3.155 1.91 0 3.109 1.072 4.686 1.072 1.532 0 2.464-1.074 4.672-1.074 1.668 0 3.432.93 4.694 2.535-4.126 2.314-3.455 8.34.712 9.954zM15.917 4.06C16.72 3.004 17.33 1.516 17.108 0c-1.31.091-2.84.947-3.735 2.055-.812 1.01-1.484 2.51-1.223 3.96 1.43.046 2.91-.827 3.767-1.956z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconIosFilled;